import { CERoleGrantBase } from './ce-role-grant-base'


export class CERoleGrant extends CERoleGrantBase {

}